import { render, staticRenderFns } from "./PartnerDetailView.vue?vue&type=template&id=862b8082&"
import script from "./PartnerDetailView.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports